import * as firebase from 'firebase';

import { FIREBASE_SERVICE_ACCOUNT } from './api'

const firebaseApp = firebase.initializeApp(FIREBASE_SERVICE_ACCOUNT)

export default firebaseApp
